/**
 * 인증이 필요한 라우트를 보호하는 컴포넌트
 * - 로그인하지 않은 사용자는 /login으로 리다이렉트
 * - requireRole이 지정되면 해당 role이 아닌 사용자는 /albums로 리다이렉트
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import type { UserRole } from '../api/auth.api';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireRole?: UserRole;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireRole }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireRole && user?.role !== requireRole) {
    return <Navigate to="/albums" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
